import gql from 'graphql-tag';

export const CREATE_ASSESSMENT_TYPE = gql`
  mutation CreateAssessmentType($input: CreateAssessmentTypeInput!) {
    createAssessmentType(input: $input) {
      id
      name
      description
      max_score
      is_ca
      is_exam
      sequence
      subject_id
      academic_calendar_id
    }
  }
`;

export const UPDATE_ASSESSMENT_TYPE = gql`
  mutation UpdateAssessmentType($input: UpdateAssessmentTypeInput!) {
    updateAssessmentType(input: $input) {
      id
      name
      description
      max_score
      is_ca
      is_exam
      sequence
      subject_id
      academic_calendar_id
    }
  }
`;

export const DELETE_ASSESSMENT_TYPE = gql`
  mutation DeleteAssessmentType($id: ID!) {
    deleteAssessmentType(id: $id) {
      success
      message
      deleted_count
    }
  }
`;

export const REORDER_ASSESSMENT_TYPES = gql`
  mutation ReorderAssessmentTypes($order_data: [AssessmentTypeOrderInput!]!) {
    reorderAssessmentTypes(order_data: $order_data) {
      success
      message
    }
  }
`;

export const COPY_CBT_SCORES_TO_ASSESSMENT = gql`
  mutation CopyCbtScoresToAssessment($input: CopyCbtScoresToAssessmentInput!) {
    copyCbtScoresToAssessment(input: $input) {
      success
      message
      copied_count
      updated_count
      skipped_count
      errors
    }
  }
`;
